// 发布小程序把这个文件删除了 走接口获取
export const secret = '4xw4aaj8XOmOV34N'